import { getFeathersClient } from "@/lib/feathers/client";
import { log } from "@/logger";
import type { AuthenticationResult } from "@spork/feathers-client";

export async function signInWithLocal(
    email: string,
    password: string
): Promise<AuthenticationResult> {
    log.debug("Signing in with local strategy");
    const client = getFeathersClient();
    return client.authenticate({
        strategy: "local",
        email,
        password,
    });
}
